module.exports = __webpack_public_path__ + "static/media/MaterialCommunityIcons.b62641af.ttf";